import { Stack, Typography } from '@mui/material';
import { VyTooltip } from '../../../../components/new-design/VyTooltip';
import { isNotEmptyString } from '@vy/utils';
import { formatDate } from '../../../../utils/date';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

type LightInvoiceActivityEventProps = {
  label: string;
  date: Date;
  isLast: boolean;
  email?: string;
  success?: boolean;
};

export const LightInvoiceActivityEvent: React.FC<LightInvoiceActivityEventProps> = ({
  label,
  date,
  isLast,
  email,
  success = true,
}) => {
  return (
    <div className="flex ">
      {!isLast && (
        <div
          style={{
            position: 'absolute',
            left: '7px',
            marginTop: '12px',
            width: '2px',
            height: '47px',
            backgroundColor: '#E0E0E0',
          }}
        />
      )}
      <Stack direction="row" spacing={2} sx={{
        alignItems: "flex-start"
      }}>
        {success ? (
          <CheckCircleIcon
            sx={{
              width: 16,
              height: 16,
              color: '#01A452',
              zIndex: 99,
            }}
          />
        ) : (
          <CancelIcon
            sx={{
              width: 16,
              height: 16,
              color: '#E0E0E0',
              zIndex: 99,
            }}
          />
        )}
        <Stack direction="column" sx={{
          justifyContent: "center"
        }}>
          <Typography
            variant="body2"
            sx={{ fontWeight: 400, color: 'text.primary', fontSize: 14, lineHeight: 1 }}
          >
            {isNotEmptyString(email) ? (
              <VyTooltip tooltipContent={email} placement="bottom-start">
                <span>{label}</span>
              </VyTooltip>
            ) : (
              label
            )}
          </Typography>

          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
              fontSize: 12,
              lineHeight: 2,
            }}
          >
            {formatDate(date)}
          </Typography>
        </Stack>
      </Stack>
    </div>
  );
};
